(function () {
 'use strict';

 angular
   .module('tfc.retailer.Purchase', [])
   .config(config);

 // @ngInject
 function config($stateProvider) {

   $stateProvider
     .state('purchase', {
       abstract : true,
       parent : 'pageWithMenu',
       url : '/purchase',
       data : {
         auth : { privilege : 'report.PurchaseAttribute' }
       },
       template : '<ui-view></ui-view>'
     })
     .state('purchase.attributes', {
       url : '/attributes?brandKey&department&category&attribute&attributeValue&transaction&region',
       templateUrl : 'Purchase/PurchaseAttributes.tmpl.html',
       controller : 'PurchaseAttributesCtrl as vm',
       data : {
         requireTerms:true,
         title:'Purchase Attributes',
         path:'purchase/PurchaseAttributes'
       },
       resolve : {
         selectedBrandKey: function (PurchaseAttribute, $stateParams) {
           return PurchaseAttribute.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
             $stateParams.brandKey = selectedBrandKey;
             return selectedBrandKey;
           });
         },
         filters: function (PurchaseAttribute, $stateParams, activityRegion, selectedBrandKey) {
             return activityRegion( function() {
               return PurchaseAttribute.getPurchaseAttributeFilters(selectedBrandKey)
             },$stateParams.transaction, $stateParams.region);
         },
         userBrands : function (BrandReports) {
           return BrandReports.findUserBrandNames();
         },
         attributeHierarchies : function(PurchaseAttribute, BrandReports, filters, Enums, selectedBrandKey) {
             var transaction = filters.getSelected();
             var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
             return PurchaseAttribute.getAttributeHierarchies(selectedBrandKey, transaction && transaction.getLabel(), region);
         },
         attributes : function(attributeHierarchies, $stateParams) {
           var selectedHierarchy = _.find(attributeHierarchies, function(o){
             return o.department === $stateParams.department && o.category === $stateParams.category
           });
           if(selectedHierarchy){
             return _.uniq(_.map(selectedHierarchy.attributes, 'attribute')).sort();
           }
         },
         attributeValues : function(attributeHierarchies, attributes, $stateParams) {
           var selectedHierarchy = _.find(attributeHierarchies, function(o){
             return o.department === $stateParams.department && o.category === $stateParams.category
           });
           if(selectedHierarchy){
             var selectedAttribute = _.find(selectedHierarchy.attributes, function(o){
               return o.attribute.key === $stateParams.attribute;
             });
             if(selectedAttribute){
               var attributeValues = selectedAttribute.attributeValues.sort();
               attributeValues.unshift({key: 'ALL',value: 'ALL',isActive: true});
               return attributeValues;
             }
           }
         },
         hierarchyFilter : function(attributeHierarchies, HierarchyFilter, $stateParams) {
           return HierarchyFilter(attributeHierarchies,
             $stateParams.hierarchy, $stateParams.department, $stateParams.category);
         },
         attributeFilter : function(attributes, hierarchyFilter, AttributeFilter, $stateParams) {
           return AttributeFilter(attributes,
             $stateParams.attribute, hierarchyFilter);
         },
         attributeValueFilter : function(attributeValues, attributeFilter, AttributeValueFilter, $stateParams) {
               return AttributeValueFilter(attributeValues, $stateParams.attributeValue, attributeFilter);
         },
         salesByAttribute : function (PurchaseAttribute, $stateParams, filters, selectedBrandKey) {
             var transaction = filters.getSelected();
             var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
             if($stateParams.department && $stateParams.category && $stateParams.attribute && $stateParams.attributeValue)
               return PurchaseAttribute.getSalesByAttribute(selectedBrandKey, $stateParams.department, $stateParams.category, $stateParams.attribute,
                   transaction && transaction.getLabel(), region);
         },
         salesByConsumerAge : function(PurchaseAttribute, $stateParams, filters, selectedBrandKey) {
             var transaction = filters.getSelected();
             var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
             if($stateParams.department && $stateParams.category && $stateParams.attribute && $stateParams.attributeValue)
               return PurchaseAttribute.getSalesByConsumerAge(selectedBrandKey, $stateParams.department, $stateParams.category, $stateParams.attribute,
                   $stateParams.attributeValue, transaction && transaction.getLabel(), region);
         },
         salesByConsumerBmi : function(PurchaseAttribute, $stateParams, filters, selectedBrandKey) {
             var transaction = filters.getSelected();
             var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
             if($stateParams.department && $stateParams.category && $stateParams.attribute && $stateParams.attributeValue)
               return PurchaseAttribute.getSalesByConsumerBmi(selectedBrandKey,  $stateParams.department, $stateParams.category, $stateParams.attribute,
                   $stateParams.attributeValue, transaction && transaction.getLabel(), region);
         },
         aggregationLogDetails: function(BrandReports) {
           return BrandReports.getDashboardAggregationLogDetails('PurchaseAttribute');
         }
       }
     })
 }

})();